const debtPaymentEn = {
	debt_payment: {
		title: "Customer Debt Payment Report",
		table: {
			title: "Customer Debt Payment Report Data",
			columns: {
				date: "Date",
				cust_name: "Customer Name",
				store: "Store",
				ref_id: "Ref ID",
				total: "Total",
				status: "Status",
			},
			status: {
				success: "Success",
				failed: "Failed",
			},
		},
		empty_state: {
			title: "No customer debt payment report data yet",
			description: "No customer debt payment report data yet",
		},
	},
};
export default debtPaymentEn;
